import Cookies from 'js-cookie';

export const DEFAULT_SERVICE_NUMBER = '800-293-4232';
const ttarpOverrideCookie = Cookies.get('ttarp_override');
export const serviceNumber = ttarpOverrideCookie ? ttarpOverrideCookie : DEFAULT_SERVICE_NUMBER;
